export default {
  clearTags: value => {
    const div = document.createElement("div");
    div.innerHTML = value;
    const text = div.textContent || div.innerText || "";
    return text;
  }
};



// WEBPACK FOOTER //
// ./src/filters/string.js